import * as Sentry from '@sentry/browser';

Sentry.init({
    dsn: 'https://155e24486d654a6ab93172f89992dcc4@sentry.io/296542',
    tracesSampleRate: 0.01,
    sampleRate: 0.01,
    enabled: true,
    debug: false,
    maxBreadcrumbs: 50,
    integrations: [new Sentry.BrowserTracing({
        beforeNavigate: (context) => {
            const url = context.name;

            // Replace specific patterns in the URL with corresponding placeholders
            let modifiedName = modifyUrl(url);

            if (modifiedName === url) {
                modifiedName = ':other';
            }

            return {
                ...context,
                name: modifiedName,
            };
        },
        shouldCreateSpanForRequest: (url) => {
            const currentDomain = window.location.hostname;

            // Define the allowed domain(s)
            const allowedDomains = ['viya.co.za'];

            // Define the disallowed subdomain(s)
            const disallowedSubdomains = ['stage'];

            const subdomain = currentDomain.split('.')[0]; // Extract the subdomain

            if (!allowedDomains.includes(currentDomain) || disallowedSubdomains.includes(subdomain)) {
                // If the current domain is not in the allowed list or the subdomain is disallowed, return false to prevent creating a span
                return false;
            }

            return true; // Create a span for allowed domains
        },
    })],
    tracePropagationTargets: ["localhost", /^https:\/\/www\.lekkeslaap\.co\.za$/]
});

Sentry.addGlobalEventProcessor(function (event, hint) {
    if (event.type == 'transaction') {
        if (window.location.pathname == modifyUrl(window.location.pathname)) {
            return null
        }
    }
    const error = hint.originalException

    if (error && error.message) {
        // check if the error is queueMicrotask or flatMap and ignore it
        if (error.message.match(/queueMicrotask|flatMap/)) {
            return null;
        }
    }

    return event;
});

function modifyUrl(url) {
    // Define regular expressions to replace specific patterns with placeholders, order is important
    const placeholders = {
        ":region-map": /\/(?:accommodation|akkommodasie)-in\/[^/]+\/(?:kaart|map)/,
        ":region-near": /\/(?:accommodation|akkommodasie)-(?:near|naby)\/[^/]+/,
        ":book": /\/(?:accommodation|akkommodasie)\/[^/]+\/(?:book|bespreek)/,
        ":region": /\/(?:accommodation|akkommodasie)-in\/[^/]+/,
        ":view": /\/(?:accommodation|akkommodasie)\/[^/]+/,
        ":homepage": /^(\/|\/en)$/, // Match only / or /en
    };

    // Replace specific patterns in the URL with corresponding placeholders
    let modifiedName = url;

    for (const placeholder in placeholders) {
        const regex = placeholders[placeholder];
        const match = url.match(regex);
        if (match) {
            return placeholder;
        }
    }

    return modifiedName;
}
